import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import BillingHistoryComponent from './billing-history.component';

export const BillingHistory = connect((appState: AppState) => ({
  appState,
  //@ts-ignore
}))(BillingHistoryComponent as any) as unknown as typeof BillingHistoryComponent;
